import { Lot } from "./Lot";

export class TypeLotsDivers {

  public tousLots: string;

  public plusieursLot: string;

  public unLot: string;

	public lot: Lot[];

  constructor() {
    this.tousLots = null;
    this.plusieursLot = null;
    this.unLot = null;
    this.lot = [];
  }
}
